import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

import { useLocale } from "context/locale"

import RoundedWrapper from "components/RoundedWrapper"
import { CareerForm } from "components/Forms"

import { fadeAnimation } from "utils"

const ApplyNow = ({ data }) => {
  const { t } = useLocale()

  return (
    <section className="career-apply-now">
      <RoundedWrapper className="career-apply-now__wrapper">
        <div className="row justify-content-center">
          <motion.div className="col-xl-6" {...fadeAnimation}>
            <h2>{t("Apply now")}</h2>
            <p className="career-apply-now__desc">
              {t("Want to work with us? Use a form below and send us your CV!")}
            </p>
            <CareerForm position={data?.title} />
          </motion.div>
        </div>
      </RoundedWrapper>
    </section>
  )
}

export default ApplyNow
